import React from 'react';
import { Spin } from 'antd';
import Layout from '../../components/layout/Layout';
import PasswordScreen from './partials/passwordScreen';
import EventScreen from './partials/eventScreen';
import './eventShareView.scss';

import srcFleetclearLogo from '../../assets/images/fleetclear-logo.svg';

export default function () {
    const { report, match, isFetching, user } = this.props;
    const {
        isValid, eventId, deviceId, reference, historicVideoId,
    } = report || {};
    const { params } = match;

    const showPasswordScreen = isValid === true && ((!eventId && !deviceId) || params.code !== report.code);
    const showEventScreen = isValid === true
        && (eventId || reference || historicVideoId)
        && report.deviceId
        && params.code === report.code;

    return (
        
        <Layout
            data-test="pages-events-share-view"
            className="events-view"
            title="Event View"
            isVisibleHeader={false}
            headerTitle={<div>Shared Web Report</div>}
            showFooter={false}
            loading={isFetching}
            overrideUseSidebarStyle
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <div 
                    className="content"
                    style={{ 
                        opacity: isFetching ? 0 : 1,
                        height: '95vh',
                        overflow: 'hidden',
                    }}
                >
                    <div className="content-inner">
                        <section className="section">
                            {showPasswordScreen
                                ? <PasswordScreen params={params} />
                                : null}
                            {showEventScreen
                                ? <EventScreen params={params} parent="sharedView" />
                                : null}

                            {!showPasswordScreen && !showEventScreen
                                ? (
                                    <div className="loginform-wrap">
                                        <div className="loginform-container">
                                            <div className="d-flex dir-column align-center text-center">
                                                <img src={srcFleetclearLogo} className="login__logo-fleet" alt="Fleetclear" />
                                                <h1 className="login__heading">Invalid link!</h1>
                                            </div>
                                        </div>
                                    </div>
                                )
                                : null}
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
        
    );
}
